//#region INTERFACE
interface Props {
  removeHandler?: (value: string) => void;
  index: number;
  value: string;
}
//#endregion

export default function InstoreOrderFormTrackAndTraceBadge({
  removeHandler,
  index,
  value,
}: Props) {
  //#region RENDER
  return (
    <span className="inline-flex items-center gap-x-1 rounded-full bg-emerald-500 px-3 py-1.5 text-xs font-bold text-white hover:bg-emerald-400">
      <a href={value} target="_blank" rel="noreferrer">
        {`TRACK PARCEL ${index + 1}`}
      </a>
      {removeHandler ? (
        <button
          type="button"
          className="group relative -mr-1 size-3.5 rounded-xs hover:bg-emerald-600/20"
          onClick={() => removeHandler(value)}
        >
          <svg
            viewBox="0 0 14 14"
            className="h-4 w-4 stroke-white group-hover:stroke-emerald-800/75"
          >
            <path d="M4 4l6 6m0-6l-6 6" />
          </svg>
        </button>
      ) : null}
    </span>
  );
  //#endregion
}
